@if (state == 'editing') {
	<div class="media-control-status">Opening media library...</div>
} @else if (state == 'empty') {
	<button class="media-control-action" mat-raised-button (click)="enableEditing()">
		{{ emptyButtonLabel }}
	</button>
} @else if (state == 'present') {
	<div class="media-control-present">
		<div class="media-control-toolbar">
			<button class="media-control-action" mat-raised-button (click)="enableEditing()">
				{{ presentButtonLabel }}
			</button>
		</div>

		<div class="media-control-preview">
			<media-image [imageId]="imageId" />
		</div>
	</div>
} @else if (state == 'processing') {
	<div class="media-control-status">Preparing image...</div>
} @else if (state == 'disabled') {
	<div class="media-control-status">Image selection is disabled.</div>
} @else {
	<div class="media-control-status">Image selection is unavailable.</div>
}
